// import React from 'react'

import img1 from "../../media/images/GurugramContent1.jpg";
import img2 from "../../media/images/GurugramContent2.jpg";

const LocationContentDelhi = () => {
  return (
    <div>
      <div className="location-content">
        <div className="location-content-main">
          <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
          </div>

          <div className="location-content-section">
            <h3 className="location-content-heading">
              🐶 <span>Delhi’s</span> Favourite At-Home Pet{" "}
              <span>Grooming</span> | FluffyTouch
            
            </h3>
            <div className="location-content-text">
              "From Vasant Kunj to Mayur Vihar - We Cover All 11 Districts!". 📞
              Delhi Helpline: 96581 89189 | 🌐 Areas Served: All colonies, DDA
              flats & farmhouses

           
            </div>

            <div className="location-content-image">
              <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
            </div>

            <section>
              <div className="location-content-sub-heading">
                Delhi Pet Problems? We Know Them All!
              </div>
              <div className="location-content-text">
               <ul>
                <li>South Delhi: Posh pooches needing spa days after Lodhi Garden walks</li>
                <li>West Delhi: Stray fur struggles in Punjabi Bagh summers</li>
                <li>East Delhi: Yamuna-side pets needing anti-mud baths</li>
                <li>NCR: Gurugram commuters booking weekend slots</li>
               </ul>
              </div>

              <div className="location-content-sub-heading">
                Why Delhi Chooses Us?
              </div>
              <div className="location-content-text">
                ✔ Delhi-Trained Staff: Handle VIP pets from Shanti Niketan to Sainik Farms
<br />✔ Park Smart: Mobile units service Nehru Park, Sanjay Van regulars
<br />✔ Traffic Beaters: We navigate Delhi’s jams with bike groomers

              </div>

              <div className="location-content-sub-heading">
                Book for Any Delhi Location
              </div>
              <div className="location-content-text">
                <ol>
                  <li>WhatsApp "DELHIGROOM" to 96581 89189</li>
                  <li>Get same-day slots (7 AM-9 PM)</li>
                  <li>Enjoy 20% OFF with code DELHILOVE</li>
                </ol>

                ⚠️ Delhi Pro Tip: Book early mornings to beat traffic delays!
              </div>

              <div className="location-content-sub-heading">
                Book in 2 Delhi Minutes!
              </div>
              <div className="location-content-text">
                <ol>
                  <li>WhatsApp "GROOM" to 96581 89189</li>
                  <li>Get instant slot confirmation</li>
                  <li>Enjoy ₹200 OFF first booking (Delhi special!)</li>
                </ol>
              </div>
            </section>

            <div className="location-content-sub-heading">
              Real Delhi Testimonials
            </div>
            <div className="location-content-text">
              "Only groomers who understand my Lutyens’ Labrador!" - Aditya, Chanakyapuri
              <br /> "Saved my Persian from monsoon mats in GK-1!" - Ananya, Greater Kailash

            </div>

            <div className="location-content-sub-heading"></div>
            <div className="location-content-text"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationContentDelhi;
